/**
 * Rotating red goal beacon — CSS only, no images, no video, no sound.
 * One soft-edged beam at ~1.5 rotations per second = 1.5 bright passes per
 * second, well under the 3/s photosensitivity ceiling. Reduced motion gets a
 * steady dome with a gentle glow and no rotation. Always red, never the brand
 * accent.
 */
export const GoalBeacon = () => (
    <div className="goal-beacon" data-testid="goal-beacon" aria-hidden="true">
        <style>{`
.goal-beacon { position: relative; display: flex; justify-content: center; margin-bottom: 14px; }
.goal-beacon__edge {
    position: fixed; inset: 0; pointer-events: none; z-index: 5;
    background: conic-gradient(from 0deg,
        rgba(255,32,32,0.42) 0deg, rgba(255,32,32,0.06) 55deg,
        rgba(255,32,32,0) 150deg, rgba(255,32,32,0) 300deg,
        rgba(255,32,32,0.42) 360deg);
    mask: radial-gradient(circle at 50% 50%, transparent 55%, #000 100%);
    -webkit-mask: radial-gradient(circle at 50% 50%, transparent 55%, #000 100%);
    animation: goal-beacon-spin 0.667s linear infinite;
}
.goal-beacon__dome {
    position: relative; width: 86px; height: 86px; border-radius: 9999px;
    overflow: hidden; z-index: 6;
    background: radial-gradient(circle at 50% 35%, #7f1d1d 0%, #450a0a 70%, #1f0505 100%);
    box-shadow: 0 0 34px 10px rgba(255,32,32,0.45), inset 0 0 18px rgba(0,0,0,0.6);
}
.goal-beacon__beam {
    position: absolute; inset: -30%;
    background: conic-gradient(from 0deg,
        rgba(255,70,70,0.95) 0deg, rgba(255,40,40,0.35) 42deg,
        rgba(255,0,0,0) 120deg, rgba(255,0,0,0) 300deg,
        rgba(255,70,70,0.95) 360deg);
    filter: blur(2px);
    animation: goal-beacon-spin 0.667s linear infinite;
}
.goal-beacon__lens {
    position: absolute; inset: 0; border-radius: 9999px;
    background: radial-gradient(circle at 50% 30%, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0) 45%);
}
@keyframes goal-beacon-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) {
    .goal-beacon__beam, .goal-beacon__edge { animation: none; }
    .goal-beacon__beam { background: radial-gradient(circle at 50% 50%, rgba(255,60,60,0.9) 0%, rgba(255,0,0,0.25) 70%); filter: none; }
    .goal-beacon__edge { background: radial-gradient(circle at 50% 0%, rgba(255,32,32,0.28) 0%, rgba(255,32,32,0) 60%); mask: none; -webkit-mask: none; }
}
        `}</style>
        <div className="goal-beacon__edge" />
        <div className="goal-beacon__dome">
            <div className="goal-beacon__beam" />
            <div className="goal-beacon__lens" />
        </div>
    </div>
);

export default GoalBeacon;
